import { Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { NessusScanHistory } from '../../../../../../core/models';

@Component({
  selector: 'dbx-admin-nessus-scan-history-option',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './admin-nessus-scan-history-option.component.html',
  styleUrl: './admin-nessus-scan-history-option.component.scss',
})
export class AdminNessusScanHistoryOptionComponent {
  @Input({ required: true }) history!: NessusScanHistory;
}
